import { BrowserRouter, Switch } from 'react-router-dom';
import UserProvider from '@contexts/UserContext/UserProvider';
import AuthRoute from '@router/AuthRoute';
import PreventedRoute from '@router/PreventedRoute';
import DefaultTemplate from '@style/DefaultTemplate';
import { Login, SignUp, Main, Profile, Detail } from '@pages';

const Router = () => {
  return (
    <BrowserRouter>
      <UserProvider>
        <Switch>
          <DefaultTemplate>
            <PreventedRoute path="/login" component={Login} exact />
            <PreventedRoute path="/signup" component={SignUp} exact />
            <AuthRoute path="/post/:id" component={Detail} exact />
            <AuthRoute path="/profile/:id" component={Profile} exact />
            <AuthRoute path="/" component={Main} exact />
          </DefaultTemplate>
        </Switch>
      </UserProvider>
    </BrowserRouter>
  );
};

export default Router;
